import { useState, useMemo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import "../../../assets/css/slotplaning/new_slot/newslot.scss";
import LeftMenu from "../../../Components/Layout/LeftMenu";
import Header from "../../../Components/Layout/Header";

import { ReactComponent as ChartIcon } from "../../../assets/images/sidebar/chart.svg";
import { ReactComponent as ExdIcon } from "../../../assets/images/sidebar/exp_doc.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/images/sidebar/settings.svg";
import { ReactComponent as ManualIcon } from "../../../assets/images/sidebar/manual.svg";

import { ReactComponent as PdIcon } from "../../../assets/images/sidebar/planning.svg";
import { ReactComponent as AtIcon } from "../../../assets/images/sidebar/alltrips.svg";
import { ReactComponent as ImportIcon } from "../../../assets/images/sidebar/import.svg";
import { ReactComponent as ExportIcon } from "../../../assets/images/sidebar/export.svg";
import { ReactComponent as RfsIcon } from "../../../assets/images/sidebar/rfs.svg";
import { ReactComponent as UldIcon } from "../../../assets/images/sidebar/uld.svg";

import { ReactComponent as DC } from "../../../assets/images/settings_icon/settings.svg";
import { ReactComponent as SC } from "../../../assets/images/settings_icon/slotsettings.svg";
import { ReactComponent as RS } from "../../../assets/images/settings_icon/resourcesettings.svg";
import Uprofile from "../../../assets/images/profile.png";

import AllTrips from "./Components/AllTrips";
import PlanningDashboard from "./Components/PlanningDashboard";
import Settings from "../../Settings/SettingsNew";
import CommonCard from "../../../Components/common/CommonCard";
import RfsMonitor from "./Components/RfsMonitor";
import OvDetails from "./RFSMonitor/OrdersViewDetails";
import KCharts from "./Components/Charts";

import TripView from "./RFS/TripView";
import OrderView from "./RFS/OrderView";
import AwbView from "./RFS/AwbView";
import OrdersViewDetails from "./RFSMonitor/OrdersViewDetails";
import Flights from "./Inbound/Flights";
import Shipments from "./Inbound/Shipments";
import Warehouse from "./Components/Warehouse";
import { useUserCheckQuery } from "../../../redux/services/Auth";


const Slot = () => {

  const initialTab = localStorage.getItem("MainTab");
  const initialSub = localStorage.getItem("SubTab");
  const initPage = localStorage.getItem("InnerPage") || '';
  const tabs = ['PD', 'AT', 'IB', 'RFS', 'WH', 'KC', 'EXP', 'ST', 'ML', 'SR', 'SD'].includes(initialTab);

  const [mainTab, setMainTab] = useState(tabs ? initialTab : 'PD');
  const [subTab, setSubTab] = useState(initialSub || '');
  const initTitle = { title: 'Slotplanning' }
  const [sendHeader, setSendHeader] = useState(initTitle);
  const [innerPage, setInnerPage] = useState(initPage || '');

  const [isIconClosed, setIsIconClosed] = useState(true);
  const [userDetails, setUserDetails] = useState();

  const sections = ['main', 'report', 'settings'];
  const navItems = {
    home: true,
    main: [
      { path: 'PD', name: 'Planning Dashboard', heading: 'Planning Dashboard', icon: <PdIcon className='menu-icon' /> },
      { path: 'AT', name: 'All Trips', heading: 'All Trips', icon: <AtIcon className='menu-icon' /> },
      // { path: 'IM', name: 'Import', heading: 'Import', uc: true, icon: <ImportIcon className='menu-icon' /> },
      // { path: 'EX', name: 'Export', heading: 'Export', uc: true, icon: <ExportIcon className='menu-icon' /> },
      {
        path: 'RFS', name: 'RFS', icon: <RfsIcon className='menu-icon' />, sub: [
          { path: 'TV', name: 'Trip View', heading: 'RFS - Trip View', default: true },
          { path: 'OV', name: 'Order View', heading: 'RFS - Order View', },
          { path: 'AV', name: 'AWB View', heading: 'RFS - AWB View', }
        ]
      },
      {
        path: 'IB', name: 'Inbound', icon: <ImportIcon className='menu-icon' />, sub: [
          { path: 'FT', name: 'Flights', heading: 'Inbound Flights', default: true },
          { path: 'SM', name: 'Shipments', heading: 'Inbound Shipments', },
        ]
      },
      { path: 'WH', name: 'Warehouse', icon: <UldIcon className='menu-icon' /> },
      // { path: 'SR', name: 'Shift Report', heading: 'Shift Report', icon: <AtIcon className='menu-icon' /> },
    ],
    report: [
      { path: 'KC', name: 'KPI Charts', uc: true, icon: <ChartIcon className='menu-icon' /> },
      { path: 'EXP', name: 'Export', uc: true, icon: <ExdIcon className='menu-icon' /> },
    ],
    settings: [
      { path: 'ST', name: 'Settings', heading: 'Settings', icon: <SettingsIcon className='menu-icon' /> },
      { path: 'ML', name: 'Manual', uc: true, icon: <ManualIcon className='menu-icon' /> },
    ]
  };

  const settingsNav = [
    {
      name: 'Slotplanning',
      items: [
        { name: 'Door Configuration', path: '#', icon: <DC />, tab: 'spl_drc', default: true },
        { name: 'Slot Settings', path: '#', icon: <SC />, tab: 'spl_slt', },
        // { name: 'Trucker Settings', path: '#', image: Uprofile, tab: 'trs', },
        // { name: 'Airline Settings', path: '#', image: Uprofile, tab: 'ars', },
        { name: 'Resource Settings', path: '#', icon: <RS />, tab: 'spl_rss', },
      ]
    },
    // {
    //   name: 'Shift Report',
    //   items: [
    //     { name: 'Assets', path: '#', icon: <SC />, tab: 'spl_ast', default: true },
    //     { name: 'Groups', path: '#', icon: <RS />, tab: 'spl_grp', },
    //   ]
    // }
  ];
  const handleCollapse = (value) => {
    setIsIconClosed(value);
  };

  useEffect(() => {
    // const findRow = navItems?.main?.main?.find(i => i.path === mainTab)
    const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === mainTab)
    // console.log('findRow', findRow);
    if (findRow?.sub && initialSub) {
      const subRow = findRow.sub.find(i => i.path === initialSub)
      // setSubHead(subRow?.heading || subRow?.name)
      setSendHeader({
        ...initTitle,
        subTitle: subRow?.heading || subRow?.name
      });
    } else {
      setSendHeader({
        ...initTitle,
        subTitle: findRow?.heading || findRow?.name
      });
    }
  }, [])

  const { data: myData } = useUserCheckQuery('', {
    // skip: pageDetails.pagesize === 0,
  });
  useEffect(() => {
    if (myData?.response_data) {
      setUserDetails(myData?.response_data);
    }
  }, [myData]);

  const handlenewLink = (page = '', main = null) => {
    console.log('page', page);

    setInnerPage(page);
    localStorage.setItem('InnerPage', page);

    if (main) {
      setMainTab(main);
      localStorage.setItem('MainTab', main);
    }
  };

  const handleNavClick = (main = null, page = '') => {
    // if (['IM', 'EX', 'UL', 'ML'].includes(main)) {
    //   toast.warning('Page is under construction!');

    // } else {
    if (page) {
      setInnerPage(page);
      localStorage.setItem('InnerPage', page);
    }
    if (main) {
      setInnerPage('');
      localStorage.setItem('InnerPage', '');

      setMainTab(main.path);
      if (main.sub) {
        // if (!initialSub) {
        // console.log('main', main);

        const findDefault = main?.sub?.find(i => i.default)
        setSubTab(findDefault?.path)
        localStorage.setItem('SubTab', findDefault?.path)
        // setSubHead(findDefault?.heading)
        setSendHeader({
          ...initTitle,
          subTitle: findDefault?.heading
        });
        // } else {
        //   setSubTab(initialSub)
        // }
      } else {
        const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === main.path)
        // setSubHead(findRow?.heading || findRow?.name)
        setSendHeader({
          ...initTitle,
          subTitle: findRow?.heading || findRow?.name
        });
        if (main.path === 'SD') {
          // setSubHead('Shift Report')
          setSendHeader({
            ...initTitle,
            subTitle: 'Shift Report'
          });
        }
      }
      localStorage.setItem('MainTab', main.path);
      // }
    }
  }
  const handleSubNav = (snav) => {
    // console.log('snav', snav);
    if (snav) {
      setSubTab(snav?.path)
      localStorage.setItem('SubTab', snav?.path)
      // setSubHead(snav?.heading)
      setSendHeader({
        ...initTitle,
        subTitle: snav?.heading
      });
    }

  }

  return (
    <>
      <div className="d-flex">
        <LeftMenu userInfo={userDetails} isIconClosed={isIconClosed} selTab={mainTab} navs={navItems} onNav={handleNavClick} onSubNav={handleSubNav} />
        <div className="mainbody-right">
          <Header userInfo={userDetails} isIconClosed={isIconClosed} oncollapsed={handleCollapse} propData={sendHeader} />

          <div className="">
            {innerPage === '' &&
              <>
                {mainTab === 'PD' && <PlanningDashboard />}
                {mainTab === 'AT' && <AllTrips />}
                {mainTab === 'ST' && <Settings onSnav={settingsNav} />}
                {/* {mainTab === 'RFS' && <RfsMonitor onNav={handleNavClick} />} */}
                {mainTab === 'RFS' &&
                  <>
                    {subTab === 'TV' && <TripView />}
                    {subTab === 'OV' && <OrderView onDetails={handleSubNav} />}
                    {subTab === 'OD' && <OrdersViewDetails onNav={handleSubNav} />}
                    {subTab === 'AV' && <AwbView />}
                  </>
                }
                {mainTab === 'IB' &&
                  <>
                    {subTab === 'FT' && <Flights />}
                    {subTab === 'SM' && <Shipments />}
                  </>
                }
                {mainTab === 'WH' && <Warehouse />}
                {/* {mainTab === 'SR' && <ShiftReport onNav={handleNavClick} />} */}
                {mainTab === 'KC' && <KCharts onNav={handleNavClick} />}
              </>
            }
            {/* {innerPage === 'SD' && <ShiftDetails />} */}
            {innerPage === 'OVD' && <OvDetails onNav={handleNavClick} />}
          </div>
        </div>
      </div >
    </>
  );
};

export default Slot;